import React from 'react';

import { useIntl } from 'react-intl';

import { IconButton, type IconButtonProps } from '@atlaskit/button/new';
import CrossIcon from '@atlaskit/icon/core/cross';

import messages from './messages';

type CloseChatButtonProps = Pick<IconButtonProps, 'onClick'>;

export const CloseChatButton = ({ onClick }: CloseChatButtonProps): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<IconButton
			isTooltipDisabled={false}
			icon={(props) => <CrossIcon {...props} color="var(--ds-icon)" size="small" />}
			appearance="subtle"
			onClick={onClick}
			label={formatMessage(messages.closeChatPanelButtonLabel)}
			testId="rovo-chat-close-chat-button"
		/>
	);
};
